<script lang="ts">
	import Blok from '$lib/storyblok/blok.svelte';
	import { useStoryblokBridge } from '@storyblok/js';
	import { onMount } from 'svelte';

	let { data } = $props();

	onMount(() => {
		useStoryblokBridge(data.story.id, (newStory) => (data.story = newStory), {
			resolveRelations: ['blog_article_list.highlighted_article', 'blog_page.category']
		});
	});
</script>

<Blok content={data.story.content} />
